/**
 * Utilidades de fecha para hora Chile (UTC-4/UTC-3 con horario de verano).
 * new Date().toISOString() siempre usa UTC, lo que al final del día
 * en Chile muestra la fecha del día siguiente.
 */

/** Retorna la fecha actual en formato YYYY-MM-DD según hora Chile continental */
export const hoyChile = () => {
    const ahora = new Date();
    const offset = -4; // Chile UTC-4 (horario estándar)
    const local = new Date(ahora.getTime() + (offset * 60 * 60 * 1000));
    return local.toISOString().split('T')[0];
};

/** Retorna el primer día del mes actual en formato YYYY-MM-DD */
export const primerDiaMesChile = () => {
    const ahora = new Date();
    const offset = -4;
    const local = new Date(ahora.getTime() + (offset * 60 * 60 * 1000));
    return `${local.getFullYear()}-${String(local.getMonth() + 1).padStart(2, '0')}-01`;
};